import * as t from "io-ts";

/** Wire shape of a server DecisionGraph, the shared decision-flow model rendered by ots-ui-tw's DecisionGraph. */
export const DecisionGraphNodeValidator = t.intersection([
  t.type({
    id: t.string,
    kind: t.string,
    title: t.string,
    lines: t.array(t.string),
  }),
  t.partial({
    status: t.string,
    // RichMessage; validated where it's rendered
    messages: t.array(t.UnknownRecord),
  }),
]);

export const DecisionGraphEdgeValidator = t.intersection([
  t.type({source: t.string, target: t.string}),
  t.partial({status: t.string, explanation: t.string}),
]);

export const DecisionGraphValidator = t.type({
  nodes: t.array(DecisionGraphNodeValidator),
  edges: t.array(DecisionGraphEdgeValidator),
});

export type DecisionGraphData = t.TypeOf<typeof DecisionGraphValidator>;
